var React = require('react');

function IconCross (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12.728 1.585A.928.928 0 1011.415.272L6.5 5.187 1.585.272A.929.929 0 00.272 1.585L5.187 6.5.272 11.415a.929.929 0 001.313 1.313L6.5 7.813l4.915 4.915a.928.928 0 101.313-1.313L7.813 6.5l4.915-4.915z","fill":"#303030"}));
}

IconCross.defaultProps = {"fill":"none","viewBox":"0 0 13 13"};

module.exports = IconCross;

IconCross.default = IconCross;
